import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faEnvelope, faPhone, faGlobe } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp, faTelegram } from '@fortawesome/free-brands-svg-icons';
import '../styler.css';

const Contact = () => {
    return (
        <div className="contact-container">
            <h1>Contato</h1>
            <div className="contact-item">
                <FontAwesomeIcon icon={faUser} className="icon"/>
                <span>Nome: Leonardo Rodrigues Mattar</span>
            </div>
            <div className="contact-item">
                <FontAwesomeIcon icon={faUser} className="icon"/>
                <span>Licença: 47966</span>
            </div>
            <div className="contact-item">
                <FontAwesomeIcon icon={faEnvelope} className="icon"/>
                <span>Email: igrreen.daqui.club</span>
            </div>
            <div className="contact-item">
                <FontAwesomeIcon icon={faGlobe} className="icon"/>
                <span>Site: www.daqui.club</span>
            </div>
            <div className="contact-item">
                <FontAwesomeIcon icon={faWhatsapp} className="icon"/>
                <span>WhatsApp: +55 21 99946-2091</span>
            </div>
            <div className="contact-item">
                <FontAwesomeIcon icon={faTelegram} className="icon"/>
                <span>Telegram: @igreenleonardo_bot</span>
            </div>
        </div>
    );
};

export default Contact;
